(() => {
  const PP = window.PP = { freeShipCents: 5000, tier2: 20, tier3: 30, handle: 'the-travel-buddy', productUrl: '/products/the-travel-buddy' };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (c) => '$' + (c / 100).toFixed(2);
  const buddies = (n) => n + (n === 1 ? ' Buddy' : ' Buddies');
  PP.tierPct = (q) => (q >= 3 ? PP.tier3 : q >= 2 ? PP.tier2 : 0);

  const initHero = (root) => $$('[data-pp-hero]', root).forEach((hero) => {
    if (hero.dataset.ppReady) return; hero.dataset.ppReady = 1;
    const imgs = $$('[data-form]', hero), btns = $$('[data-pp-show]', hero);
    if (imgs.length < 2) return;
    let current = 'plush', timer;
    const show = (form) => {
      current = form;
      imgs.forEach((i) => i.classList.toggle('is-hidden', i.dataset.form !== form));
      btns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.ppShow === form)));
    };
    btns.forEach((b) => b.addEventListener('click', () => { clearInterval(timer); show(b.dataset.ppShow); }));
    if (!reduce) timer = setInterval(() => show(current === 'plush' ? 'pillow' : 'plush'), 3800);
    hero.addEventListener('pointerenter', () => clearInterval(timer), { once: true });
  });

  const initFlip = (root) => $$('[data-pp-flip]', root).forEach((stage) => {
    if (stage.dataset.ppReady) return; stage.dataset.ppReady = 1;
    const range = $('input[type=range]', stage);
    const set = (v) => stage.style.setProperty('--pp-split', v + '%');
    range.addEventListener('input', () => set(range.value));
    if (reduce || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const start = performance.now();
      const tick = (now) => {
        const t = (now - start) / 1400;
        if (t > 1) { set(50); range.value = 50; return; }
        const v = 50 + Math.sin(t * Math.PI * 2) * 22; set(v); range.value = v;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }), { threshold: 0.6 });
    io.observe(stage);
  });

  const cartExtras = async () => {
    const drawer = $('cart-drawer');
    const inner = drawer && $('.drawer__inner', drawer);
    if (!inner || inner.classList.contains('is-empty')) return;
    let cart;
    try { cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()); } catch (e) { return; }
    $$('.pp-cartship,.pp-cartup', inner).forEach((n) => n.remove());
    const host = $('.drawer__footer', inner);
    if (!host) return;
    const total = cart.total_price, left = Math.max(0, PP.freeShipCents - total);
    const pct = Math.min(100, Math.round((total / PP.freeShipCents) * 100));
    const ship = document.createElement('div');
    ship.className = 'pp-cartship' + (left === 0 ? ' is-done' : '');
    ship.innerHTML = left === 0
      ? 'You unlocked <u>free US shipping</u> 🎉<div class="pp-bar"><i style="width:100%"></i></div>'
      : 'You are <strong>' + money(left) + '</strong> away from free US shipping.<div class="pp-bar"><i style="width:' + pct + '%"></i></div>';
    host.prepend(ship);
    const count = cart.items.filter((i) => i.handle === PP.handle).reduce((a, i) => a + i.quantity, 0);
    if (count === 1 || count === 2) {
      const up = document.createElement('div');
      up.className = 'pp-cartup';
      up.innerHTML = '<span>Add ' + (count === 1 ? 'a 2nd Buddy' : 'a 3rd Buddy') + ' and save ' + PP.tierPct(count + 1) + '% on every Buddy.</span><a href="' + PP.productUrl + '#pp-builder">Choose a Buddy</a>';
      host.prepend(up);
    }
  };

  const initBuilder = (root) => {
    if (root.dataset.ppReady) return; root.dataset.ppReady = 1;
    const data = JSON.parse($('script[type="application/json"]', root).textContent);
    const variants = data.variants;
    const tiersEl = $$('input[name="pp-tier"]', root);
    const slotsEl = $('[data-pp-slots]', root);
    const addBtn = $('[data-pp-add]', root);
    const priceEl = $('[data-pp-addprice]', root);
    const labelEl = $('[data-pp-addlabel]', root);
    const errEl = $('[data-pp-error]', root);
    const shipEl = $('[data-pp-ship]', root);
    const firstAvail = variants.find((v) => v.available) || variants[0];
    const preVar = variants.find((v) => String(v.id) === new URLSearchParams(location.search).get('variant'));
    let qty = 1;
    const picks = [(preVar || firstAvail).id, null, null];
    const byId = (id) => variants.find((v) => v.id === id);
    const suggest = (i) => {
      const used = picks.slice(0, i).filter(Boolean);
      return (variants.find((v) => v.available && !used.includes(v.id)) || firstAvail).id;
    };
    const syncGallery = (v) => {
      if (!v) return;
      const gallery = document.querySelector('media-gallery[id^="MediaGallery-' + data.section + '"]');
      if (gallery && gallery.setActiveMedia && v.media_id) { try { gallery.setActiveMedia(data.section + '-' + v.media_id, true); } catch (e) {} }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      const st = $('[data-pp-sticky-img]'); if (st && v.image) st.src = v.image;
    };
    const update = () => {
      const chosen = picks.slice(0, qty).map(byId).filter(Boolean);
      const full = chosen.reduce((a, v) => a + v.price, 0);
      const pct = PP.tierPct(qty);
      const final = chosen.reduce((a, v) => a + v.price - Math.floor(v.price * pct / 100), 0);
      priceEl.innerHTML = pct ? money(final) + ' <s style="opacity:.6;font-weight:500">' + money(full) + '</s>' : money(final);
      labelEl.textContent = qty > 1 ? 'Add ' + buddies(qty) + ' to cart' : 'Add to cart';
      addBtn.disabled = !(chosen.length === qty && chosen.every((v) => v.available));
      const left = Math.max(0, PP.freeShipCents - final);
      const w = Math.min(100, Math.round((final / PP.freeShipCents) * 100));
      if (shipEl) shipEl.innerHTML = left === 0
        ? '🚚 This order ships <u>free</u> (US).<div class="pp-bar"><i style="width:100%"></i></div>'
        : '🚚 ' + money(left) + ' away from free US shipping, or grab a Buddy Pack.<div class="pp-bar"><i style="width:' + w + '%"></i></div>';
      const sp = $('[data-pp-sticky-price]'); if (sp) sp.textContent = money(final) + (pct ? ' · save ' + pct + '%' : '');
    };
    const renderSlots = () => {
      slotsEl.innerHTML = '';
      for (let i = 0; i < qty; i++) {
        if (!picks[i]) picks[i] = suggest(i);
        const slot = document.createElement('div');
        slot.className = 'pp-bb__slot';
        slot.innerHTML = '<div class="pp-bb__slothead">' + (qty > 1 ? 'Buddy ' + (i + 1) + ':' : 'Your Buddy:') + ' <b data-name></b></div><div class="pp-bb__swatches" role="radiogroup" aria-label="Choose Buddy ' + (i + 1) + '"></div>';
        $('[data-name]', slot).textContent = byId(picks[i]).title;
        const sw = $('.pp-bb__swatches', slot);
        variants.forEach((opt) => {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'pp-sw'; b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', String(opt.id === picks[i]));
          b.setAttribute('aria-label', opt.title + (opt.available ? '' : ' (sold out)'));
          b.title = opt.title; b.disabled = !opt.available;
          if (opt.image) b.style.backgroundImage = 'url("' + opt.image + '")';
          b.addEventListener('click', () => {
            picks[i] = opt.id;
            $$('.pp-sw', sw).forEach((x) => x.setAttribute('aria-checked', String(x === b)));
            $('[data-name]', slot).textContent = opt.title;
            if (i === 0) syncGallery(opt);
            update();
          });
          sw.appendChild(b);
        });
        slotsEl.appendChild(slot);
      }
    };
    tiersEl.forEach((t) => t.addEventListener('change', () => { qty = Number(t.value); renderSlots(); update(); }));
    addBtn.addEventListener('click', async () => {
      errEl.hidden = true;
      const counts = {};
      picks.slice(0, qty).forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
      const items = Object.keys(counts).map((id) => ({ id: Number(id), quantity: counts[id] }));
      const cart = document.querySelector('cart-drawer');
      const body = { items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map((s) => s.id); body.sections_url = location.pathname; }
      addBtn.disabled = true;
      const old = labelEl.textContent; labelEl.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart. Please try again.');
        if (cart && cart.renderContents && json.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(Object.assign({}, json, { id: items[0].id }));
          setTimeout(cartExtras, 400);
        } else {
          location.href = '/cart';
        }
      } catch (e) {
        errEl.textContent = e.message; errEl.hidden = false;
      } finally {
        labelEl.textContent = old; update();
      }
    });
    renderSlots(); update();
    if (preVar) syncGallery(preVar);
    const sticky = $('[data-pp-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
      }).observe(addBtn);
      $('[data-pp-sticky-btn]', sticky).addEventListener('click', () => root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }));
    }
  };

  const initAll = (root = document) => { initHero(root); initFlip(root); $$('[data-pp-builder]', root).forEach(initBuilder); };
  const boot = () => {
    initAll();
    if (location.hash === '#pp-builder') { const b = $('#pp-builder'); if (b) setTimeout(() => b.scrollIntoView({ block: 'center' }), 300); }
    const drawer = $('cart-drawer');
    if (drawer) {
      let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(cartExtras, 150); }).observe(drawer, { childList: false, attributes: true, attributeFilter: ['class'] });
      cartExtras();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();